import { useState } from "react";
import Tabs from "../Tabs/Tabs";
import Template, { Content, Header, Main } from "../Template/Template";
import Typo from "../Typo/Typo";
import Button from "../Button/Button";
import { Link } from "react-router-dom";

export default function Design() {
  document.title = "Design system";

  const sections = [
    { id: "actions", title: "Actions", component: DesignActions },
    { id: "inputs", title: "Inputs", component: DesignInputs },
    { id: "feedback", title: "Feedback", component: DesignFeedback },
    { id: "data-display", title: "Data Display", component: DesignDataDisplay },
  ];

  const [selectedID, setSelectedID] = useState(sections[0].id);

  const DesignComponent = sections.find(
    (step) => step.id === selectedID,
  ).component;

  return (
    <Template>
      <Main themeSwitch>
        <Header onBackButtonClick={() => window.location.reload()}>
          <Typo variant="h1">Design system</Typo>
          <Typo variant="body2">Non exhaustive list of components</Typo>
        </Header>

        <Tabs
          tabs={sections}
          onSelect={(id) => setSelectedID(id)}
          selectedID={selectedID}
        />

        <Content>
          <DesignComponent />
        </Content>
      </Main>
    </Template>
  );
}

function DesignActions() {
  const buttonVariants = [
    "primary_a",
    "primary_b",
    "secondary_a",
    "secondary_b",
    "tertiary_a",
  ];
  return (
    <section id="actions">
      <Typo variant={"h2"} style={{ margin: " 1rem 0" }}>
        Buttons
      </Typo>
      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
        {buttonVariants.map((variant) => (
          <Button key={variant} text={variant} variant={variant} />
        ))}
        <Button text={"disabled"} variant={buttonVariants[0]} disabled />
      </div>

      <Typo variant={"h2"} style={{ margin: " 1rem 0" }}>
        Links
      </Typo>
      <div>
        <Link>Link</Link>
      </div>
    </section>
  );
}

function DesignInputs() {
  return <section id="inputs"></section>;
}

function DesignFeedback() {
  return <section id="feedback"></section>;
}

function DesignDataDisplay() {
  return <section id="data-display"></section>;
}
